export const GET_MULTIMEDIA = 'GET_MULTIMEDIA';
export const GET_MULTIMEDIA_BY_BRAND = 'GET_MULTIMEDIA_BY_BRAND';
export const SET_IS_LOADING_MEDIA = 'SET_IS_LOADING_MEDIA';
export const SET_IS_LOADING_MORE_MEDIA = 'SET_IS_LOADING_MORE_MEDIA';
export const SET_BRAND_SELECTED = 'SET_BRAND_SELECTED';
export const RESET_BRAND_SELECTED = 'RESET_BRAND_SELECTED';
export const SEARCH_MEDIA = 'SEARCH_MEDIA';
export const GET_VIDEOS_BY_BRAND = 'GET_VIDEOS_BY_BRAND';
export const RESET_MEDIA = 'RESET_MEDIA';
